import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of, Subject } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { environment as ENV } from "environments/environment";
import { PageOrdenCompraDTO } from "../../interfaces/page-orden-compra.interface";

import { FiltrosService } from "../util/filtros.service";
import { OrdenCompraDTO } from "../../models/orden-compra.model";
import { map } from "rxjs/operators";
import { DetalleOrdenCompraDTO } from "../../interfaces/detalle-orden-compra.interface";

const API = "ordenescompra";

@Injectable({
    providedIn: "root",
})
export class OrdenesCompraService {
    ordenesChanged$: Subject<PageOrdenCompraDTO>;
    ordenChanged$: Subject<OrdenCompraDTO>;
    ooccRefresh$: BehaviorSubject<boolean>;
    tieneInformeChanged$: Subject<boolean>;
    private paginaActual: number;
    private cantidaResultadosPorPagina: number;
    private totalDeResultados: number;
    private cantidadPaginas: number;
    private orden: string;
    private campoOrden: string;
    constructor(private http: HttpClient, private _filtros: FiltrosService) {
        this.ordenesChanged$ = new Subject();
        this.ordenChanged$ = new Subject();
        this.tieneInformeChanged$ = new Subject();
        this.ooccRefresh$ = new BehaviorSubject(null);

        this.resetPaginador();
    }

    setCantidadPaginas(cantidadPaginas: number): void {
        this.cantidadPaginas = cantidadPaginas;
    }

    getCantidadPaginas(): number {
        return this.cantidadPaginas;
    }

    getTotalDeResultados(): number {
        return this.totalDeResultados;
    }

    setTotalDeResultados(totalDeResultados: number): void {
        this.totalDeResultados = totalDeResultados;
    }

    setOrden(orden: string): void {
        this.orden = orden;
    }

    setCampoOrden(campoOrden: string) {
        this.campoOrden = campoOrden;
    }

    getOrden(): string {
        return this.orden;
    }

    setPaginaActual(pagina: number): void {
        this.paginaActual = pagina;
    }

    getPaginaActual(): number {
        return this.paginaActual;
    }

    setCantidaResultadosPorPagina(cantidadResultados: number): void {
        this.cantidaResultadosPorPagina = cantidadResultados;
    }

    getCantidaResultadosPorPagina(): number {
        return this.cantidaResultadosPorPagina;
    }

    resetPaginador() {
        //console.log("pasooooooo");
        this.paginaActual = 0;
        this.cantidaResultadosPorPagina = 10;
        this.totalDeResultados = 0;
        this.cantidadPaginas = 0;
        this.campoOrden="numero"
        this.orden = "asc";
    }

    fetchOrdenCompra(idOOCC: number): Observable<DetalleOrdenCompraDTO> {
        return this.http.get<DetalleOrdenCompraDTO>(
            `${ENV.apiUrl}${API}/${idOOCC}`
        );
    }

    fetchOrdenesCompra(
        cliente?: string,
        rut?: string,
        estado?: number,
        nroOOCC?: number
    ): Observable<PageOrdenCompraDTO> {

        const filtrosOOCC = this._filtros.getFiltro("filtrosOOCC");
        //console.log(filtrosOOCC);
        
        let parametros:string='';
        parametros+=(filtrosOOCC.cliente[0].valor != '')?'&idCliente='+filtrosOOCC.cliente[0].valor:'';
        parametros+=(filtrosOOCC.estado[0].valor>0)?'&estadoFacturacion='+filtrosOOCC.estado[0].valor:'';
        parametros+=(filtrosOOCC.nroOOCC[0].valor != '')?'&numero='+filtrosOOCC.nroOOCC[0].valor:'';
        parametros+=(filtrosOOCC.rut[0].valor != '')?'&rut='+filtrosOOCC.rut[0].valor:'';
        parametros+=(filtrosOOCC.recepcion[0].valor>0)?'&estadoRecepcion='+filtrosOOCC.recepcion[0].valor:'';

        return this.http.get<PageOrdenCompraDTO>(
            `${ENV.apiUrl}${API}?page=${
                this.paginaActual
            }&size=${this.cantidaResultadosPorPagina}${parametros}&sort=${this.campoOrden},${this.orden}`
        );

        /*
        return this.http.get<PageOrdenCompraDTO>(
            `${ENV.apiUrl}${API}?idCliente=${
                cliente || filtrosOOCC.cliente[0].valor
            }&estadoFacturacion=${estado || filtrosOOCC.estado[0].valor}&rut=${
                rut || filtrosOOCC.rut[0].valor
            }&numero=${nroOOCC || filtrosOOCC.nroOOCC[0].valor}&page=${
                this.paginaActual
            }&size=${this.cantidaResultadosPorPagina}&sort=${this.campoOrden},${this.orden}`
        );
        */
    }

    delete(idOOCC: number): Observable<any>{
        return this.http.delete(`${ENV.apiUrl}${API}/${idOOCC}`);
    }

    saveNumeroGes(informe:File, nroGes: number, idOOCC: number): Observable<any> {
        var form = null;
        if (informe){
            form = new FormData();
            form.append("documento", informe, informe.name);
        }    
        return this.http.post(
            `${ENV.apiUrl}${API}/${idOOCC}/recibir?ges=${nroGes}`,
            form,{
                reportProgress: true,
            }
        );
    }

    updateNumeroGes(informe:File, nroGes: number, idOOCC: number): Observable<any> {
        var form = null;
        //console.log(informe);
        if (informe){
            form = new FormData();
            form.append("documento", informe, informe.name);
        }    
        return this.http.patch(
            `${ENV.apiUrl}${API}/${idOOCC}/recepcion?ges=${nroGes}`,
            form,{
                reportProgress: true,
            }
        );
    }

    asociarOOTTAOOCC(ordenCompra: OrdenCompraDTO): Observable<any> {
        return this.http.post(`${ENV.apiUrl}${API}`, ordenCompra);
    }

    saveFile(fb:FormData,idOOCC: number){
        return this.http.patch(
            `${ENV.apiUrl}${API}/${idOOCC}/recepcion?ges=`,fb,{
                reportProgress: false,
                observe: 'events'
              }
        );
    }

    fetchReport(inicio:string, termino:string, sucursales:number[], esSupervisor:boolean): Observable<Blob>{
        const requestOptions: Object = {
            responseType: "blob",
            reportProgress: true,
        };

        let parametros:string="";
        if (esSupervisor){
            sucursales.forEach(s=>{
                parametros+=`&clientes=${s}`;     
            })
        }
        if (!esSupervisor){
            sucursales.forEach(s=>{
                parametros+=`&sucursales=${s}`;     
            })
        }

        return this.http.get<any>(
            `${ENV.apiUrl}${API}/reporte?inicio=${inicio}&fin=${termino}${parametros}`,requestOptions
        );
    }

    fetchDocumento(idOOCC: number): Observable<Blob> {
        const requestOptions: Object = {
            responseType: "blob",
            reportProgress: true,
        };
        return this.http.get<any>(
            `${ENV.apiUrl}${API}/${idOOCC}/recepcion`,requestOptions
        );
    }


    saveInforme(idOOCC:number, informe:File):Observable<any>{
        let form = new FormData();
        form.append("informe", informe, informe.name);
        
        return this.http.post(
            `${ENV.apiUrl}${API}/${idOOCC}/informe`,form,{
                reportProgress: false,
                observe: 'events'
              }
        );
    }

    fetchInforme(idOOCC:number):Observable<Blob>{
        const requestOptions: Object = {
            responseType: "blob",
            reportProgress: true,
        };
        return this.http.get<any>(
            `${ENV.apiUrl}${API}/${idOOCC}/informe`,requestOptions
        );
    }
}
